import lozadInitiator from "../global/lozadInitiator";
import animations from "../global/animations";
import {throttle} from "../global/helpers";

// Separate from the other archiveAjax due to extra Region JS
const archiveLocationsAjax = {
    init() {
        const regionGroups = Array.from(document.getElementsByClassName('js-region'));
        const filtersForm = document.getElementById('filters-form');
        const loadMoreEls = Array.from(document.getElementsByClassName('js-load-more'));
        const resetFilters = filtersForm.getElementsByClassName('js-reset-filters')[0];
        const inputEls = Array.from(filtersForm.getElementsByClassName('js-input-filter'));
        const selectEls = Array.from(filtersForm.getElementsByClassName('js-select-filter'));
        const radiosEls = Array.from(filtersForm.getElementsByClassName('js-radio-filter'));
        let selects = {};
        let inputs = {};
        let radios = {};

        updateInputs(inputEls, filtersForm, loadMoreEls, selects, inputs, radios);
        updateSelects(selectEls, filtersForm, loadMoreEls, selects, inputs, radios);
        updateRadios(radiosEls, filtersForm, loadMoreEls, regionGroups, selects, inputs, radios);
        updateRegions(regionGroups, filtersForm, loadMoreEls, selects, inputs, radios);
        initializeLoadMores(filtersForm, loadMoreEls, selects, inputs, radios);
        filterPosts(selects, inputs, radios, filtersForm, loadMoreEls);

        resetFilters.onclick = (evt) => {
            evt.preventDefault();

            filtersForm.reset();
            for(var i=0;i<radiosEls.length;i++)
                radiosEls[i].checked = i === 0;
            for(var i=0;i<inputEls.length;i++)
                inputEls[i].value = '';

            selects = {};
            inputs = {};
            radios = {};

            regionGroups.forEach((region) => {
                region.classList.remove('active');
            });

            filterPosts(selects, inputs, radios, filtersForm, loadMoreEls);
        };
    }
}

const pushHistory = (filtersForm) => {
    const formData = new FormData(filtersForm);
    const formObj = [...formData.entries()]
        .filter(val => !val.includes('search_terms') && !!val[1])
        .reduce((acc, field) => {
            const [key, value] = field;
            if (acc.hasOwnProperty(key)) {
                acc[key] = [...acc[key], value].join(',');
                return { ...acc }
            } else {
                return { ...acc, [key]: value }
            }
        }, {});
    
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams) {
            const url = new URL(window.location);

            for(const [key, value] of searchParams.entries()) {
                const input = document.querySelector(`#${key}`);
                if (input) {
                    input.value = decodeURI(value);
                }
            }
            url.search = new URLSearchParams(formObj);
            history.pushState({}, '', url);
        }
};

const filterPosts = (selects, inputs, radios, filtersForm, loadMoreEls, paged = 1, isLoadMoreClick = false) => {
    const postsWrapper = document.getElementById('posts-wrapper');
    const action = postsWrapper.getAttribute('data-action');

    pushHistory(filtersForm);
    postsWrapper.style.opacity = 0.3;
    postsWrapper.style.transition = "opacity 0.3s ease-in-out";

    fetch(cdScriptsObj.ajax_url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: new URLSearchParams({
            action: action,
            selects: JSON.stringify(selects),
            inputs: JSON.stringify(inputs),
            radios: JSON.stringify(radios),
            paged: paged,
            isLoadMoreClick: isLoadMoreClick,
        }),
    }).then(response => {
        response.json().then(results => {
            postsWrapper.style.opacity = 1;
            if (paged > 1) {
                postsWrapper.innerHTML += results.cards;
            } else {
                postsWrapper.innerHTML = results.cards;
            }

            lozadInitiator.init();
            animations.init();

            loadMoreEls.forEach((loadMore) => {
                loadMore.setAttribute('data-next-page', results.paged);
                loadMore.setAttribute('data-max-num-pages', results.max_num_pages);

                if (results.paged > results.max_num_pages) {
                    loadMore.classList.add('hide');
                } else {
                    loadMore.classList.remove('hide');
                }
            });
        });
    }).catch(err => {
        postsWrapper.style.opacity = 1;
        console.error(err)
    });
};

const updateRegions = (regionGroups, filtersForm, loadMoreEls, selects, inputs, radios) => {
    regionGroups.forEach((region) => {
        const termID = region.dataset.region;
        const radio = filtersForm.querySelector('input[data-term-id="' + termID + '"]');
        if (radio && radio.checked) {
            if (region.dataset.region == radio.dataset.termId) {
                region.classList.add('active');
            }
        }

        region.addEventListener('click', () => {
            regionGroups.forEach((region) => {
               region.classList.remove('active');
            });

            region.classList.add('active');

            radio.checked = true;
            const radioName = radio.getAttribute('name');
            radios[radioName] = radio.value;

            filterPosts(selects, inputs, radios, filtersForm, loadMoreEls);
        });
    });
};

const updateInputs = (inputEls, filtersForm, loadMoreEls, selects, inputs, radios) => {
    inputEls.forEach((input) => {
        const inputName = input.getAttribute('name');
        inputs[inputName] = input.value;

        input.oninput = throttle(() => {
            inputs[inputName] = input.value;

            if (input.value.length !== 1) {
                filterPosts(selects, inputs, radios, filtersForm, loadMoreEls);
            }
        }, 500);
    });
};

const updateSelects = (selectEls, filtersForm, loadMoreEls, selects, inputs, radios) => {
    selectEls.forEach((select) => {
        const selectName = select.getAttribute('name');
        selects[selectName] = select.value;

        select.onchange = () => {
            selects[selectName] = select.value;

            filterPosts(selects, inputs, radios, filtersForm, loadMoreEls);
        };
    });
};

const updateRadios = (radioEls, filtersForm, loadMoreEls, regionGroups, selects, inputs, radios) => {
    radioEls.forEach((radio) => {
        const radioName = radio.getAttribute('name');
        if (radio.checked) {
            radios[radioName] = radio.value;
        }

        radio.onchange = () => {
            if (radio.checked) {
                radios[radioName] = radio.value;
            }

            regionGroups.forEach((region) => {
                region.classList.remove('active');
            });

            if (radio.value !== '0') {
                regionGroups.forEach((region) => {
                    if (region.dataset.region === radio.dataset.termId) {
                        region.classList.add('active');
                    }
                });
            }

            radio.checked = true;

            filterPosts(selects, inputs, radios, filtersForm, loadMoreEls);
        };
    });
};

const initializeLoadMores = (filtersForm, loadMoreEls, selects, inputs, radios) => {
    loadMoreEls.forEach((loadMore) => {
        loadMore.onclick = () => {
            filterPosts(selects, inputs, radios, filtersForm, loadMoreEls, loadMore.getAttribute('data-next-page'), true);
        };
    });
};

archiveLocationsAjax.init();
